import React from 'react';
import { Flex } from '../../ui';
import styled from 'styled-components'
import { CONTENT_WIDE, media } from '../../utils/media'
import theme from '../theme'
import { toRgba } from '../theme/colors'

const Band = styled.div`
  width: 100%;
  background-color: ${toRgba(theme.colors.NEU_50, 0.5)};
`

const Wrapper = styled(Flex)`
  max-width: ${CONTENT_WIDE}px ;
  margin: auto;
  padding: 1rem 0.5rem;
  ${media.lessThan('desktop')} {
    padding: 1rem;
  }
  ${media.lessThan('mobile')} {
    padding:1rem 0.5rem 0.5rem;
  }
`

const SubMenuWrapper = ({ children, ...props }) => {

  return (
    <Band>
      <Wrapper {...props}>
        {children}
      </Wrapper>
    </Band>
  );
};

export default SubMenuWrapper;
